import { useEffect } from "react";

import { initializeApp } from "firebase/app";
import {
  fetchAndActivate,
  getRemoteConfig,
  getValue,
} from "firebase/remote-config";

import { FIREBASE_APP, backgroundImage } from "utils/constants";
import { FIREBASE_REMOTE_CONFIG_KEY } from "config";
import { dispatch } from "store";
import { setFireBaseDetails } from "store/slices/Firebase";

const FirebaseRemoteConfig = () => {
  useEffect(() => {
    const app = initializeApp(FIREBASE_APP);
    const remoteConfig = getRemoteConfig(app);

    // set time interval to re-fetch the data from firebase remote config
    remoteConfig.settings.minimumFetchIntervalMillis = 0;

    fetchAndActivate(remoteConfig)
      .then(() => {
        const value = getValue(remoteConfig, `firebaseSettings`);

        if (value) {
          // parsing the firebase returned object to make it usable
          const parsedValue = JSON.parse(JSON.stringify(value));

          if (parsedValue?._value) {
            // parsing the stringified value
            const response = JSON.parse(parsedValue?._value);

            const {
              ticker: { textColor, bodyColor, message, businessId, visibility },
              clarity,
            } = response[`${FIREBASE_REMOTE_CONFIG_KEY}`];

            // updating store to get updating details
            dispatch(
              setFireBaseDetails({
                ticker: {
                  textColor: textColor ? textColor : "#000000",
                  bodyColor: bodyColor ? bodyColor : "#FFA500",
                  message: message ? message : "",
                  businessId: businessId ? businessId : "",
                  visibility:
                    typeof visibility === "boolean" ? visibility : false,
                },
                clarity,
                auth: {
                  login: response?.login,
                  signup: response?.signup,
                },
              })
            );
          }
        }
      })
      .catch((err) => console.error(err));
  }, []);

  return <></>;
};

export default FirebaseRemoteConfig;
